import Categories from '../Components/Categories/Categories'
import DataSet from '../Components/DataSet/DataSet'
import Footer from '../Components/Footer/Footer';
import Header from '../Components/Header/Header';
import Banner from '../Components/Banner/Banner';
import SearchBox from '../Components/SearchBox/SearchBox';
import AllCategoriesData from '../Components/AllCategoriesData/AllCategoriesData';
import { Helmet } from 'react-helmet';
import Translate from '../Components/Translate/Translate';
import Concat from '../Components/Concat/Concat';
import MetaTags from '../Components/MetaTags/MetaTags';


const MainPage = () => {


 

  return (
    <div className='main-container'>
      <MetaTags title={"Open Data Tel-Aviv"} description={"Open Data Tel-Aviv"}/>      
      <Header/>
      <Banner/>
      <div className='mainContent' role="main">
        <SearchBox/>
        <div role="tablist">
          <AllCategoriesData/>
          {/* <DataSet/> */}
        </div>
        <Concat/>
      </div>
      <Footer/>

    </div>
  )
}

export default MainPage